// extracted by mini-css-extract-plugin
module.exports = {"dialerControlButton--clicked":"styles_dialerControlButton--clicked__26mts"};